<template>
<div>
    <div class="text-center" style="padding: 2em 0 1em;">
      <img src="/static/imgs/logo.png"/>
    </div>

    <div id="formBox" class="panel panel-primary page">
      <div class="panel-heading">
        <span class="panel-title">Forgot your password?</span>
      </div>

      <!-- Success state: shown after the request goes through. -->
      <template v-if="sent">
        <div class="panel-body">
          <div class="alert alert-success" style="margin-bottom: 0;">
            <strong>Check your email.</strong>
            If an account exists for <strong>{{ submitted_email }}</strong>, we've
            sent password reset instructions. It can take a few minutes to arrive &mdash;
            remember to check your spam folder.
          </div>
        </div>
        <div class="panel-footer text-right">
          <a class="btn btn-primary" href="" @click.prevent="go_to_login">Back to login</a>
        </div>
      </template>

      <!-- Request form. -->
      <form v-else novalidate class="form-horizontal" role="form" @submit.prevent="send_forgot">
        <div class="panel-body">
          <p class="text-muted">
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <div class="form-group">
            <input type="email" v-model="email" class="form-control floating-label"
                   data-hint="Enter your email address." placeholder="Email"
                   :disabled="sending">
          </div>

          <div v-if="error" class="alert alert-danger" style="margin-bottom: 0;">
            {{ error }}
          </div>
        </div> <!-- .panel-body -->

        <div class="panel-footer zztext-right">
          <a class="btn btn-warning" href="" @click.prevent="go_to_login">Login</a>
          <button type="submit" class="btn btn-primary pull-right" :disabled="sending">
            {{ sending ? "Sending..." : "Reset Password" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>
  export default {
    data() {
      return {
        email: "",
        submitted_email: "",
        error: "",
        sending: false,
        sent: false,
      }
    },
    methods: {
      async send_forgot() {
        if (this.sending) {
          return;
        }
        this.error = "";

        if (!this.email) {
          this.error = "Please enter your email address.";
          return;
        }

        this.sending = true;
        let reset = null;
        try {
          const response = await this.$http.post("/api/reset/request/", {
            email: this.email,
          });
          reset = await response.json();
          if (!response.ok) {
            this.error = reset.error || "Something went wrong. Please try again in a moment.";
            this.sending = false;
            return;
          }
        } catch (e) {
          try {
            this.error = (await e.json()).error;
          } catch (_) {
            this.error = "Something went wrong. Please try again in a moment.";
          }
          this.sending = false;
          return;
        }

        this.sending = false;

        if (!reset.success) {
          this.error = reset.error;
          return;
        }

        // The backend intentionally returns the same response whether or not the
        // account exists (to avoid leaking which emails are registered), so the
        // confirmation is deliberately worded "if an account exists".
        this.submitted_email = this.email;
        this.sent = true;
      },
      go_to_login() {
        this.$router.push({name: "login"});
      },
    },
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/ResetRequest.vue?5b3f59ed